import axios from "axios";
import { BranchViewModel } from "./BranchViewModel";
import { LtlBidpackViewModel } from "../../Project/ViewModel/LtlBidpackViewModel";
import { cutOffTimeUrls } from "../../URL/ApplicationUrls";

export async function getBranchesRequest(rateAgreementId: string | undefined) {
  if (!rateAgreementId) {
    throw new Error("No Rate Agreement");
  }

  const url = cutOffTimeUrls.forRateAgreement.apiUrlForId(rateAgreementId);

  const response = await axios.get(url);

  const branches = response.data.Branches as Array<BranchViewModel>;
  const bidPacks = response.data.BidPacks as Array<LtlBidpackViewModel>;
  const carrierName = response.data.CarrierName;
  const carrierId = response.data.CarrierID;
  return { branches, bidpacks: bidPacks, carrierName, carrierId };
}
